module.exports = __webpack_public_path__ + "media/images/emblems/8582_wappen_dozwil-da067f68344296e3bae0855fe64956b9.png";